import CrudCustom from '../../../libs/custom/CrudCustom';

let PenghasilanSptTahunanService = new CrudCustom('/penghasilan-spt-tahunans');
export default PenghasilanSptTahunanService;
